import { SITE_CONFIG } from "../data/stories";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function captureUtmParams() {
    try {
        const params = new URLSearchParams(window.location.search);
        const found = {};
        UTM_KEYS.forEach((k) => {
            const v = params.get(k);
            if (v) found[k] = v;
        });
        if (Object.keys(found).length > 0) {
            sessionStorage.setItem("fxtm_utm", JSON.stringify(found));
            return found;
        }
        return JSON.parse(sessionStorage.getItem("fxtm_utm") || "{}");
    } catch {
        return {};
    }
}

export function getDeviceType() {
    return window.matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile";
}

export function initAnalytics() {
    window.dataLayer = window.dataLayer || [];
    const { ga4MeasurementId, gtmContainerId } = SITE_CONFIG;

    if (gtmContainerId) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gtmContainerId);
    }

    if (ga4MeasurementId) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4MeasurementId}`;
        document.head.appendChild(s);
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", ga4MeasurementId);
    }
}

export function trackEvent(eventName, params = {}) {
    const payload = {
        ...captureUtmParams(),
        device_type: getDeviceType(),
        page: window.location.pathname,
        ...params,
    };

    // GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });

    // GA4 direct (if configured without GTM)
    if (typeof window.gtag === "function") {
        window.gtag("event", eventName, payload);
    }

    // First-party backup log (survives navigation via sendBeacon)
    try {
        const body = JSON.stringify({ event: eventName, params: payload, ts: new Date().toISOString() });
        if (navigator.sendBeacon) {
            navigator.sendBeacon(`${BACKEND_URL}/api/track`, new Blob([body], { type: "application/json" }));
        } else {
            fetch(`${BACKEND_URL}/api/track`, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true });
        }
    } catch {
        /* analytics must never break the page */
    }
}

export function trackStoryClick(story) {
    const params = {
        story_id: story.id,
        story_name: story.category,
        content_category: story.category,
        content_type: story.contentType,
        destination_url: story.instagramUrl,
    };
    trackEvent(`instagram_story_${story.id}_click`, params);
    trackEvent("outbound_instagram_click", params);
}

export function isDesktopLinkContext() {
    return window.matchMedia("(hover: hover) and (min-width: 1024px)").matches;
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
